// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_4d-0";
export var eligibilityCardNotEligible = "_4d-1";